<template>
  <div class="moow-master-container play-background">
    <!-- <nav-default></nav-default> -->
    <md-toolbar class="md-primary play-toolbar dark" md-elevation="1">
      <span style="flex: 1">
        {{dt.maaklerID}} |
        <b>{{dt.location.address.street}} {{dt.location.address.number}} - {{dt.location.address.apartNumber}}</b>
      </span>
      <h3 class="md-title" style="flex: 1">{{dt.marketingDet.shortDesc}}</h3>
      <md-button @click="cancel()">{{cancelButtonTextValue}}</md-button>
      <md-button v-if="showDeleteInsteadOfSave" @click="deleteListing">Delete</md-button>
      <md-button v-else-if="showPublishInsteadOfSave" @click="publish">Publish</md-button>
      <md-button v-else @click="saveAndExitGate">Save / exit</md-button>

      <md-button @click="exitToPreview()">Preview</md-button>
    </md-toolbar>
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>

    <div class="container mb-5">
      <b-row class="tabs-container">
        <b-col>
          <!-- <el-tabs v-model="activeName"> -->
          <md-tabs
            :md-active-tab="activeName"
            class="md-primary play-tabs makeup"
            md-elevation="2"
            md-dynamic-height
            @md-changed="changedTab"
          >
            <md-tab id="first" md-label="Description">
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Marketing Title</p>
                      <md-field>
                        <md-input
                          v-model="dt.marketingDet.shortDesc"
                          :placeholder="i18n_local.moow_title_placeholder"
                          required
                        ></md-input>
                        <span class="md-error">Required</span>
                      </md-field>
                    </md-card-content>
                  </md-card>

                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Portals Title</p>
                      <md-steppers md-vertical>
                        <md-step id="est" md-label="Estonia">
                          <md-field>
                            <md-input
                              v-model="dt.genDet.slogan.est"
                              placeholder="Teised portaalid kasutavad seda pealkirjana"
                            ></md-input>
                          </md-field>
                        </md-step>

                        <md-step id="eng" md-label="English">
                          <md-field>
                            <md-input
                              v-model="dt.genDet.slogan.eng"
                              placeholder="Many portals use this as the title!"
                            ></md-input>
                          </md-field>
                        </md-step>

                        <md-step id="rus" md-label="Russia">
                          <md-field>
                            <md-input
                              v-model="dt.genDet.slogan.rus"
                              placeholder="многие порталы используют это как название!"
                            ></md-input>
                          </md-field>
                        </md-step>
                      </md-steppers>
                    </md-card-content>
                  </md-card>

                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Description</p>
                      <md-steppers md-vertical>
                        <md-step id="est" md-label="Estonia">
                          <textarea
                            rows="10"
                            cols="50"
                            v-model="dt.genDet.info.est"
                            placeholder="Pikem kirjeldus, lisa puhas tekst."
                          ></textarea>
                          <!-- <md-field>
                            <label>Pikem kirjeldus, lisa puhas tekst.</label>
                          </md-field>-->
                        </md-step>

                        <md-step id="eng" md-label="English">
                          <textarea
                            rows="10"
                            cols="50"
                            v-model="dt.genDet.info.eng"
                            placeholder="Longer Description, enter only pure text"
                          ></textarea>
                          <!-- <md-field>
                            <label></label>
                          </md-field>-->
                        </md-step>

                        <md-step id="rus" md-label="Russia">
                          <textarea
                            rows="10"
                            cols="50"
                            v-model="dt.genDet.info.rus"
                            placeholder="Более длинное описание, введите только чистый текст."
                          ></textarea>
                          <!-- <md-field>
                            <label>Более длинное описание, введите только чистый текст.</label>
                          </md-field>-->
                        </md-step>
                      </md-steppers>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>

            <md-tab id="location-tab" md-label="Location" md-dynamic-height>
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Location</p>
                      <b-row v-if="loading">
                        <b-col>
                          <p>Loading...</p>
                        </b-col>
                      </b-row>
                      <div v-else>
                        <b-row class="custom mt-2">
                          <b-col lg="12">{{dt.location.address.formattedAD}}</b-col>
                          <b-col
                            lg="12"
                          >{{dt.location.address.street}} {{dt.location.address.number}} - {{dt.location.address.apartNumber}}, {{dt.location.address.municipality}}</b-col>
                          <b-col lg="12">{{dt.location.address.county}}</b-col>
                          <b-col lg="12">{{dt.location.address.country}}</b-col>
                        </b-row>
                        <md-list :md-expand-single="expandSingle">
                          <md-list-item md-expand :md-expanded.sync="expandNews">
                            <md-icon>map</md-icon>
                            <span class="md-list-item-text">Edit Location</span>

                            <md-list slot="md-expand">
                              <div style="padding-left:2em;padding-right:2em;">
                                <p
                                  style="font-size: 12px;text-align:left;font-style:italic "
                                >*changing address doesn't update the building details automatically</p>
                                <location-search
                                  :existingLocation="dt.location"
                                  :confirmLocationCallback="updateLocation"
                                ></location-search>
                              </div>
                            </md-list>
                          </md-list-item>
                        </md-list>
                      </div>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>

            <md-tab id="second" md-label="Details" md-dynamic-height>
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Property Details</p>
                      <b-row>
                        <b-col class="align-self-center">
                          <b-form-group
                            horizontal
                            breakpoint="lg"
                            label="Property Type"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-select
                              v-model="selectedPropertySuperType"
                              v-validate="'required'"
                              :options="propertyType"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            horizontal
                            breakpoint="lg"
                            label="Sub Property Type"
                            label-for="subPropertyInput"
                            align="left"
                          >
                            <b-form-select
                              v-model="selectedPropertySubType"
                              v-validate="'required'"
                              name="subPropertyInput"
                              :state="errors.has('subPropertyInput')?false:null"
                              id="subPropertyInput"
                              :options="subPropertyOptions"
                            ></b-form-select>
                            <span
                              v-show="errors.has('subProperty')"
                              class="help is-danger"
                            >{{ errors.first('subProperty') }}</span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="General Area"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-input
                              v-validate="'required|decimal'"
                              :state="errors.has('general area')?false:null"
                              name="general area"
                              type="text"
                              style="text-align:center"
                              :disabled="disabled"
                              v-model.number="generalArea"
                              placeholder="Size (m²)"
                            />
                            <span
                              v-show="errors.has('general area')"
                              class="help is-danger"
                            >{{ errors.first('general area') }}</span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Living Area"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-input
                              v-validate="'decimal'"
                              :state="errors.has('living area')?false:null"
                              name="living area"
                              type="text"
                              style="text-align:center"
                              :disabled="disabled"
                              v-model.number="dt.techDet.livingArea"
                              placeholder="Size (m²)"
                            />
                            <span
                              v-show="errors.has('living area')"
                              class="help is-danger"
                            >{{ errors.first('living area') }}</span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Entry Floor/ Number of Floors*"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-row style="border:none" class="text-center" align-v="center">
                              <b-col>
                                <b-form-input
                                  v-validate="'required|integer'"
                                  name="entryFloorInput"
                                  :state="errors.has('entryFloorInput')?false:null"
                                  id="entryFloorInput"
                                  type="text"
                                  class="text-center"
                                  :disabled="disabled"
                                  v-model="dt.techDet.entryFloor"
                                />
                              </b-col>
                              <b-col md="1">/</b-col>
                              <b-col>
                                <b-form-input
                                  v-validate="'required|integer'"
                                  name="nrOfFloorsInput"
                                  :state="errors.has('nrOfFloorsInput')?false:null"
                                  id="nrOfFloorsInput"
                                  class="text-center"
                                  :disabled="disabled"
                                  v-model="dt.techDet.buildingNrOfFloor"
                                />
                              </b-col>
                            </b-row>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Condition *"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-select
                              v-validate="'required'"
                              name="conditionInput"
                              id="conditionInput"
                              :state="errors.has('conditionInput')?false:null"
                              v-model="dt.techDet.condition"
                              :disabled="disabled"
                              :options="condition"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col>
                              <b-form-group
                                horizontal
                                breakpoint="lg"
                                label="Guests"
                                label-for="inputHorizontal"
                                align="left"
                              >
                                <el-input-number
                                  v-model="dt.techDet.nrOfGuests"
                                  id="inputHorizontal"
                                  :min="1"
                                  :max="10"
                                  style="width:100%"
                                ></el-input-number>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group
                                horizontal
                                breakpoint="lg"
                                label="Rooms"
                                label-for="inputHorizontal"
                                align="left"
                              >
                                <el-input-number
                                  v-model="dt.techDet.nrOfRooms"
                                  id="inputHorizontal"
                                  :min="1"
                                  :max="10"
                                  style="width:100%"
                                ></el-input-number>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group
                                horizontal
                                breakpoint="lg"
                                label="Bedrooms"
                                label-for="inputHorizontal"
                                align="left"
                              >
                                <el-input-number
                                  v-model="dt.techDet.nrOfBedrooms"
                                  id="inputHorizontal"
                                  :min="0"
                                  :max="10"
                                  style="width:100%"
                                ></el-input-number>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group
                                id="fieldsetHorizontal"
                                horizontal
                                breakpoint="lg"
                                label="Bathrooms"
                                label-for="inputHorizontal"
                                align="left"
                              >
                                <el-input-number
                                  v-model="dt.techDet.nrOfBathrooms"
                                  id="inputHorizontal"
                                  :min="0"
                                  :max="10"
                                  style="width:100%"
                                ></el-input-number>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <!-- BALCONY -->
                          <b-row>
                            <b-col>
                              <b-form-group
                                id="fieldsetHorizontal"
                                horizontal
                                breakpoint="lg"
                                label="Balcony"
                                label-for="inputHorizontal"
                                align="left"
                              >
                                <md-switch v-model="balcon" style="float:right" class="md-primary" />
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row v-if="balcon">
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                              cols="12"
                              class="text-left pr-0"
                              style="float:right"
                            >
                              <md-radio
                                id="balconyType"
                                value="balcony"
                                v-model="selectedBalconyType"
                                class="md-primary"
                              >Balcony</md-radio>
                              <md-radio
                                id="terraceTye"
                                value="terrace"
                                v-model="selectedBalconyType"
                                class="md-primary"
                              >Terrace</md-radio>
                            </b-col>
                            <b-col
                              lg="4"
                              md="4"
                              sm="12"
                              cols="10"
                              class="text-left pr-0"
                              style="float:right"
                            >
                              <md-field>
                                <label>Size (m²)</label>
                                <md-input
                                  v-bind:disabled="!balcon"
                                  v-validate="'decimal'"
                                  v-model="areaM2"
                                ></md-input>
                              </md-field>
                            </b-col>
                            <hr class="hr-form-el-separator" />
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group
                                id="fieldsetHorizontal"
                                horizontal
                                breakpoint="lg"
                                label="Storage"
                                label-for="radios2"
                                align="left"
                              >
                                <md-switch
                                  v-model="storage"
                                  style="float:right"
                                  class="md-primary"
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                              <b-form-group
                                v-if="storage"
                                id="fieldsetHorizontal"
                                horizontal
                                breakpoint="lg"
                                label="Storage Type"
                                label-for="radios3"
                                align="left"
                              >
                                <b-form-checkbox-group
                                  id="radios3"
                                  style="text-align:left;margin-top:4px"
                                  v-model="dt.techDet.storage"
                                  :options="storageList"
                                ></b-form-checkbox-group>
                              </b-form-group>
                            </b-col>
                            <hr class="hr-form-el-separator" />
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="WC & Bath"
                            label-for="radios4"
                            align="left"
                          >
                            <md-radio
                              :value="true"
                              v-model="dt.techDet.wcAndBathSeparated"
                              class="md-primary"
                            >Separated</md-radio>
                            <md-radio
                              :value="false"
                              v-model="dt.techDet.wcAndBathSeparated"
                              class="md-primary"
                            >Together</md-radio>
                            <b-col
                              lg="6"
                              md="6"
                              sm="12"
                              cols="12"
                              class="text-left pr-0"
                              style="float:right"
                            ></b-col>
                            <!-- <b-form-radio-group id="radios4" style="text-align:left;margin-top:4px" 
                                  :options="[{text:'Separated',value:'true'},{text:'Together',value:'false'}]"
                            v-model="dt.techDet.wcAndBathSeparated"> </b-form-radio-group>-->
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </md-card-content>
                  </md-card>

                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Building Details</p>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Building Material"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-select
                              v-model="dt.techDet.buildingMat"
                              :options="buildingMaterial"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Internal Walls"
                            label-for="radios1"
                            align="left"
                          >
                            <b-form-checkbox-group
                              id="radios1"
                              style="text-align:left;margin-top:4px"
                              v-model="dt.techDet.internalWalls"
                              :options="internalWalls"
                            ></b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="fieldsetHorizontal"
                            horizontal
                            breakpoint="lg"
                            label="Energy Label"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-select
                              v-model="dt.techDet.buildingEnLable"
                              :options="energyLabel"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-form-group
                            horizontal
                            breakpoint="lg"
                            label="Building Year"
                            label-for="inputHorizontal"
                            align="left"
                          >
                            <b-form-input
                              id="inputHorizontal"
                              type="text"
                              style="text-align:center"
                              :disabled="disabled"
                              v-model="dt.techDet.buildingYear"
                              placeholder="YYYY"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>

            <md-tab id="amenities-tab" md-label="Amenities">
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Amenities</p>
                      <listing-amenities
                        ref="amenitiesReference"
                        :selectedAmenities="selectedAmenities"
                        :selectedParkingPlacement="selectedParkingPlacement"
                        :selectedParkingPayment="selectedParkingPayment"
                        :useStoreValuesForPrePopulation="false"
                        @emitContentChanged="propertyHasChanged"
                      ></listing-amenities>
                    </md-card-content>
                  </md-card>
                </b-col>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">{{i18n_local.house_rules | capitalize}}</p>
                      <house-rules
                        :selectable="true"
                        ref="houseRulesFormRef"
                        :readonly="false"
                        :rules="houseRules"
                      />
                    </md-card-content>
                  </md-card>
                  <md-card>
                    <md-card-content>
                      <p
                        class="moow-info-txt"
                      >Property value can vary significantly depending on its added features and amenities.</p>
                      <p
                        class="moow-info-txt"
                      >Think about the type of guests that your're trying to attract and adapt your rentals' amenities to their needs. Guests staying for 30 days or longer are not tourists. They are more likely people in-between places living their day-to-day lives. They will most likely be setting up their home office in your rental.</p>
                      <p
                        class="moow-info-txt"
                      >Go through the list of Amenities carefully and select features that apply to your property.</p>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>

            <!--GALLERY-->
            <!-- <el-tab-pane label="Images" name="third"> -->
            <md-tab id="images-tab" md-label="Images" md-dynamic-height>
              <b-row>
                <b-col xl="12" lg="12" md="12" sm="12" cols="12">
                  <md-button
                    class="md-primary play-cta-button makeup"
                    @click="showImageUploadDialog"
                  >Add Images</md-button>
                  <!-- <div v-if="showUploadDialog" class="add-images-over-container"> -->
                  <md-card v-if="showUploadDialog" class="island-card">
                    <md-card-content>
                      <b-row>
                        <b-col>
                          <multi-image-uploader
                            v-if="renderImageUploader"
                            :onProgress="uploadStatus"
                            :onSuccess="uploadSuccess"
                            :onError="uploadError"
                          ></multi-image-uploader>
                        </b-col>
                      </b-row>
                    </md-card-content>

                    <md-card-actions>
                      <md-button
                        :disabled="uploadInProgress"
                        class="md-primary play-cta-button-flat grey"
                        @click="closeImageUploadDialog"
                      >Cancel</md-button>
                      <md-button
                        class="md-primary play-cta-button makeup"
                        :disabled="disableAddImage"
                        variant="primary"
                        @click="saveImageUploads"
                      >
                        <div v-if="disableAddImage" class="loader-rolling-local_white"></div>
                        <span v-else>ADD</span>
                      </md-button>
                    </md-card-actions>
                  </md-card>

                  <draggable
                    v-model="dt.marketingDet.images"
                    :options="{group:'images'}"
                    @start="drag=true"
                    @end="drag=false"
                    class="img-dragg-container moow-vert-scrollbar"
                  >
                    <!-- <div v-for="element in testDraggableArray" :key="element.id">{{element.name}}</div> -->
                    <div
                      v-for="(file,id) in dt.marketingDet.images"
                      :key="id"
                      class="mb-2 photo-uploded play-shadow"
                    >
                      <div class="img-actions-container image-box">
                        <b-img :src="file.url" alt="Thumbnail" class="image image-box-img" />
                      </div>
                      <div class="mt-2">
                        <md-field>
                          <label>Photo caption</label>
                          <md-input v-model="file.caption"></md-input>
                        </md-field>
                        <md-button @click="setcover(id)" class="md-icon-button md-dense md-primary">
                          <md-icon v-if="file.cover">favorite</md-icon>
                          <md-icon v-else>favorite_border</md-icon>
                          <md-tooltip md-direction="bottom">Set as cover</md-tooltip>
                        </md-button>
                        <md-button class="md-icon-button md-dense md-primary">
                          <md-icon disabled>open_with</md-icon>
                          <md-tooltip md-direction="bottom">Hold & dragg</md-tooltip>
                        </md-button>
                        <md-button
                          @click="removeImage(id)"
                          class="md-icon-button md-dense md-accent"
                          style="float:right"
                        >
                          <md-icon>delete</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </draggable>
                </b-col>
              </b-row>
              <md-divider></md-divider>
            </md-tab>

            <md-tab id="videos-tab" md-label="Videos" md-dynamic-height>
              <b-row>
                <b-col>
                  <md-button
                    class="md-primary play-cta-button makeup mb-3"
                    @click="addVideo()"
                  >Add Video</md-button>
                  <b-row>
                    <b-col md="6" sm="12" v-for="(data, index) in videos" :key="index">
                      <md-card class="island-card">
                        <md-card-header>
                          <md-field @md-clear="removeVideo(index)">
                            <label>Youtube link #{{data.seq+1}}</label>
                            <md-input v-model="data.url"></md-input>
                          </md-field>
                        </md-card-header>

                        <md-card-content>
                          <div class="video-preview-container">
                            <iframe
                              v-if="getEmbedLink(data.url)"
                              :src="getEmbedLink(data.url)"
                              frameborder="0"
                              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen
                            ></iframe>
                          </div>
                        </md-card-content>

                        <md-card-actions>
                          <md-button
                            @click="removeVideo(index)"
                            class="md-icon-button md-dense md-accent"
                            style="float:right"
                          >
                            <md-icon>delete</md-icon>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </md-tab>

            <!-- <el-tab-pane label="Pricing" name="fourth"> -->
            <md-tab id="fourth" md-label="Pricing" md-dynamic-height>
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <listing-pricing
                    ref="pricingReference"
                    :selectedPriceDaily="selectedPriceDaily"
                    :selectedPriceMonthly="selectedPriceMonthly"
                    :selectedEssentialFees="selectedEssentialFees"
                    :selectedCleaningFees="selectedCleaningFees"
                    :selectedDepositDaily="selectedDepositDaily"
                    :selectedWeeklyDiscount="selectedWeeklyDiscount"
                    :selectedDepositMonthly="selectedDepositMonthly"
                    :selectedUtilityFees="selectedUtilityFees"
                    :selectedMediumPeriodDiscount="selectedMediumPeriodDiscount"
                    :selectedLongPeriodDiscount="selectedLongPeriodDiscount"
                    :ucc="selectedUcc"
                    :ubc="selectedUbc"
                    @emitContentChanged="propertyHasChanged"
                  ></listing-pricing>
                </b-col>
                <b-col md="5" offset-md="1" v-if="!loading">
                  <md-card>
                    <md-card-header>
                      <div class="md-title">Moowle's Auto Price</div>
                    </md-card-header>

                    <md-card-content>
                      <auto-price-prediction :property="dt" />
                    </md-card-content>
                  </md-card>

                  <md-card>
                    <md-card-header>
                      <div class="md-title">Tips</div>
                    </md-card-header>

                    <md-card-content>
                      <p>For short-term rentals, properties with Long Stay discounts get an average of 89% more bookings</p>
                      <p>Guests looking to book longer stays actively search for properties that have a monthly rate. During periods of low demand like the covid crisis, raising your minimum stay and setting up LOS pricing can be a great way to make sure your rentals don't stay empty.</p>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>

            <!-- AVAILABILITY -->
            <md-tab id="fifth" md-label="Availability" md-dynamic-height>
              <b-row>
                <b-col xl="6" lg="6" md="8" sm="12" cols="12">
                  <md-card class="island-card">
                    <md-card-content>
                      <p class="moow-subheader">Status</p>
                      <b-row>
                        <b-col>
                          <md-field>
                            <label for="exposure">Exposure</label>
                            <md-select v-model="status" name="movie" id="movie">
                              <md-option value="draft">Delisted</md-option>
                              <md-option value="active" :disabled="disablePublish">Published (exposed to channels)</md-option>
                            </md-select>
                            <info-toggle :infoContent="i18n_local.info_publish_criterias" size="large" />

                          </md-field>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col>
                          <p class="input-header">Archive Property</p>
                        </b-col>
                        <b-col>
                          <md-switch
                            v-model="status"
                            style="float:right"
                            class="md-primary"
                            value="archived"
                          />
                        </b-col>
                      </b-row>

                      <b-row v-if="status ==='archived'">
                        <b-col>
                          <b-form-select v-model="statusDesc" :options="statusDescs"></b-form-select>
                        </b-col>
                      </b-row>
                      <md-divider></md-divider>

                      <b-row>
                        <b-col>
                          <p class="input-header">Delete Property</p>
                        </b-col>
                        <b-col>
                          <md-switch v-model="deleteThisListing" style="float:right" />
                        </b-col>
                      </b-row>
                    </md-card-content>
                  </md-card>
                </b-col>
              </b-row>
            </md-tab>
          </md-tabs>
        </b-col>
      </b-row>
    </div>

    <div>
      <moow-dialog-confirm
        title="Ignore all changes?"
        content
        confirmText="Ignore change"
        cancelText="Wait"
        :showDialog="showConfirmCancelDialog"
        @mConfirm="cancelActual"
        @mCancel="toggleCancelDialog"
      />
    </div>

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>

    <md-snackbar :md-duration="Infinity" md-persistent :md-active.sync="showActionSnackbar">
      <span>To publish, specify your identity first</span>
      <div>
        <moow-button :type="['light', 'flat', 'outlined']" btnText="GO" @mClick="navigateToAccount()"/>
      </div>
    </md-snackbar>
  </div>
</template>
<script>
import MultiImageUploader from "../components/multiImageUploader.vue";
import LocationSearch from "../components/locationSearch.vue";
import Amenities from "../components/listingComponents/listingAmenities.vue";
import Pricing from "../components/listingComponents/listingPrices.vue";
import Snackbar from "./snackbar.vue";
import {
  moveProperty,
  upsertPropertyInStorage,
  deleteProperty,
} from "../platform/properties/services/propertyService";
import Draggable from "vuedraggable";
import { RentStatus } from "../model/rentStatus.js";
import { setListingToBeReloadedUponDashboardVisit } from "../listingFunctions.js";
import { saveListingEdit } from "../listingsRepository.js";
import { updateListingVideos } from "@/listings/listingService.js";
import { getListingPrivate } from "../listings/repository/listingRepository";
import AutoPricePrediction from "../components/pricing/autoPricePrediction.vue";
import { convertUrlToEmbedLink } from "@/third-party/youtube/utils/ytHelper.js";

const lists = require("@/lists.js");

import {
  validateDateString,
  convertDateTimeToDate,
} from "../inputValidator.js";
import { listingModel } from "../dataModel.js";
import { mapGetters } from "vuex";
import HouseRules from "@/components/listingComponents/houseRulesSelector.vue";
var lodash = require("lodash/function");

export default {
  name: "editListing",
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  components: {
    draggable: Draggable,
    "multi-image-uploader": MultiImageUploader,
    "location-search": LocationSearch,
    "listing-amenities": Amenities,
    "listing-pricing": Pricing,
    "error-snackbar": Snackbar,
    "auto-price-prediction": AutoPricePrediction,
    "house-rules": HouseRules,
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  watch: {
    dt: {
      deep: true,
      handler: function (val) {
        this.propertyHasChanged();
      },
    },
    houseRules: {
      deep: true,
      handler: function (val) {
        this.propertyHasChanged();
      },
    },
    selectedPropertySubType: function (val) {
      this.propertyHasChanged();
    },
    selectedPropertySuperType: function (val) {
      this.propertyHasChanged();
    },
    generalArea: function (val) {
      this.propertyHasChanged();
    },
    balcon: function (val) {
      this.propertyHasChanged();
    },
    selectedBalconyType: function (val) {
      this.propertyHasChanged();
    },
    areaM2: function (val) {
      this.propertyHasChanged();
    },
    storage: function (val) {
      this.propertyHasChanged();
    },
    videos: function (val) {
      this.propertyHasChanged();
    },
    status: function (val, oldVal) {
      if (this.dt.availDet.status != "active" && this.status == "active") {
        this.showPublishInsteadOfSave = true;
      } else {
        this.showPublishInsteadOfSave = false;
      }
    },
    sale: function (val) {
      if (this.sale == "true") {
        this.saleView = true;
        this.rentView = false;
      } else {
        this.saleView = false;
        this.rentView = true;
      }
    },
    deleteThisListing: function (val) {
      if (val) this.showDeleteInsteadOfSave = true;
      else this.showDeleteInsteadOfSave = false;
    },
    statusDesc: function (val) {
      //this.changeRentedStateBasedOnStatus();
    },
    daily: function (val) {
      if (this.daily == "true") {
        this.dailyView = true;
      } else {
        this.dailyView = false;
      }
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    cancelButtonTextValue() {
      if (this.askExitConfirmation) return "Cancel";
      else return "Back";
    },
    disablePublish(){
      if(this.currentAccountPrivPerson) return false
      else return true
    },
    currentAccountPrivPerson() {
        var p = this.$store.getters.privatePerson;
        if (!p || Object.keys(p).length == 0){
          this.showActionSnackbar = true
          return false;
        } 
        else if (p && p.state == "loading") return "loading";
        else return p;
    },
    subPropertyOptions() {
      if (this.selectedPropertySuperType == "apartment") {
        return lists.subPropertyTypeListApartment;
      } else if (this.selectedPropertySuperType == "house") {
        return lists.subPropertyTypeListHouse;
      } else if (this.selectedPropertySuperType == "land") {
        return lists.subPropertyTypeListLand;
      } else if (this.selectedPropertySuperType == "parking") {
        return lists.subPropertyTypeListParking;
      } else if (this.selectedPropertySuperType == "commercial") {
        return lists.subPropertyTypeListCommercial;
      } else return lists.subPropertyTypeList;
    },
    showMainNavigationFooter() {
      if (this.activeName == "location-tab") return false;
      return true;
    },
    disableAddImage() {
      if (this.tempImageHolders.length <= 0 || this.uploadInProgress)
        return true;
      return false;
    },
    m2PriceComputed: function () {
      try {
        return (this.selectedPriceMonthly / this.generalArea).toFixed(2);
      } catch (err) {
        return 0;
      }
    },
    rentLableComputed: function () {
      return "Rent (" + this.dt.txnDet.currency + ")";
    },
  },
  created() {
    this.loading = true;
    this.ignoreChanges = true;

    new Promise((resolve, reject) => {
      // getListingPrivate(this.listingId)
      this.$store
        .dispatch("getProperty", { maaklerID: this.listingId })
        .then((res) => {
          this.mapping(res);
        })
        .catch((err) => {
          this.notifyUser("Failed to load property");
        })
        .finally((f) => {
          this.loading = false;
          this.ignoreChanges = false;
        });
    });
  },
  methods: {
    // TODO: Understand where this is triggered thats outside of mapping() function
    propertyHasChanged() {
      if (!this.ignoreChanges) {
        this.askExitConfirmation = true;
      }
    },
    // TODO: Implement autosave here
    autoSave: lodash.debounce(function (e) {
      console.log("autosave not yet implemented");
    }, 1000),
    getEmbedLink(videoUrl) {
      try {
        return convertUrlToEmbedLink(videoUrl);
      } catch (ex) {
        return false;
      }
    },
    removeVideo(index) {
      this.videos.splice(index, 1);
    },
    addVideo(url) {
      var s = this.videos.length;
      this.videos.push({ url: "", seq: s });
    },
    mapBackwardCompatiblePricesToNewModel(incomingTxnDet) {
      if (incomingTxnDet.price) {
        if (incomingTxnDet.txnType == "rentShortTerm")
          this.dt.txnDet.priceDaily = incomingTxnDet.price;
        else if (incomingTxnDet.txnType == "rent")
          this.dt.txnDet.priceMonthly = incomingTxnDet.price;
      }
    },
    updateLocation(location, googLocation) {
      this.dt.location = location;
      this.dt.googleLocation = googLocation;

      setListingToBeReloadedUponDashboardVisit(
        this.dt.maaklerID,
        this.dt.availDet.status,
        this.dt.availDet.status
      );
      this.notifyUser("Location updated");
      saveListingEdit(this.dt, this.objectId)
        .then((res) => {
          if (!res.body) {
            return;
          }
          this.$store.commit("UPSERT_PROPERTY", this.dt);
        })
        .catch((err) => {
          this.loading = false;
          this.notifyUser("Cannot update location right now");
        });
    },
    saveImageUploads() {
      for (var i = 0; i < this.tempImageHolders.length; i++) {
        this.dt.marketingDet.images.push({
          url: this.tempImageHolders[i].origImgUrl,
          thumb: this.tempImageHolders[i].imgUrl,
          cover: false,
          caption: "",
        });
      }
      this.closeImageUploadDialog();
      // TODO: call save here
    },
    showImageUploadDialog() {
      this.uploadInProgress = false;
      this.tempImageHolders = [];
      this.renderImageUploader = true;
      this.showUploadDialog = true;
    },
    closeImageUploadDialog() {
      this.uploadInProgress = false;
      this.tempImageHolders = [];
      this.renderImageUploader = false;
      this.showUploadDialog = false;
    },
    changePricePlaceholder() {
      if (this.dailyView) {
        this.pricePlaceholder = this.dt.txnDet.currency + " per month";
      } else {
        this.pricePlaceholder = this.dt.txnDet.currency + " per night";
      }
    },
    pushChangesAndExitTo(nextPage) {
      //this.pushVideosChanges();
      saveListingEdit(this.dt, this.objectId)
        .then((res) => {
          if (nextPage == "listing") this.exitToPreview();
          else {
            this.navigateTo(nextPage);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.notifyUser("Somthing is not right.");
        });
    },
    pushVideosChanges() {
      let vids = [];
      this.videos.forEach((video) => {
        video.url ? vids.push(video.url) : void 0;
      });
      updateListingVideos({
        listingId: this.dt._id,
        videos: vids,
      }).catch((err) => {});
    },
    cancel() {
      if (this.askExitConfirmation) this.toggleCancelDialog();
      else this.cancelActual();
    },
    toggleCancelDialog() {
      this.showConfirmCancelDialog = !this.showConfirmCancelDialog;
    },
    cancelActual() {
      this.navigateTo("dashboard");
    },
    navigateToAccount(){
      this.navigateTo( 'account', { postSaveRedirect: 'dashboard', openWithTab: 'tab-identity' });
    },
    navigateTo(where, params) {
      this.$router.push({
        name: where,
        params: params,
      });
    },
    deleteListing() {
      deleteProperty(this.dt);
      this.status = "deleted";
      this.saveAndExitTo("dashboard");
    },
    publish() {
      this.$validator.validateAll().then((result) => {
        this.mapUserInputToStoreModel();
        var customFieldsChecker = this.validateCustomRequiredFields();
        if (result && customFieldsChecker.validated) {
          this.status = "active";
          if (
            this.dt.marketingDet.images == undefined ||
            this.dt.marketingDet.images == 0
          ) {
            this.$dialog
              .confirm("Are you sure you don't want to add any pictures?")
              .then(() => {
                this.saveAndExitTo("dashboard");
              })
              .catch(function (err) {});
          } else {
            this.saveAndExitTo("dashboard");
          }
        } else {
          this.notifyUser(
            "Specify required fields: " + customFieldsChecker.message
          );
        }
      });
    },
    validateCustomRequiredFields() {
      var message = "";
      var validated = true;
      if (
        !this.dt.location.address ||
        this.anyParamIsUndefined(
          this.dt.location.address.street,
          this.dt.location.address.number,
          this.dt.location.address.municipality,
          this.dt.location.address.county
        )
      ) {
        validated = false;
        message = "Address.";
      }
      if (
        (!this.dt.txnDet.priceMonthly && !this.dt.txnDet.priceDaily) ||
        (this.dt.txnDet.priceMonthly <= 0 && this.dt.txnDet.priceDaily <= 0)
      ) {
        validated = false;
        message += "Pricing";
      }
      return {
        validated: validated,
        message: message,
      };
    },
    anyParamIsUndefined(...required) {
      for (let i = 0; i < required.length; i++) {
        if (!required[i]) return true;
      }
      return false;
    },
    saveAndExitGate() {
      // Field validation is done only on method publish
      this.saveAndExitTo("dashboard");
    },
    saveAndExitTo(here) {
      if (this.validateCustomPreSaveFields()) {
        this.loading = true;
        // sessionStorage.setItem('refreshListingId', this.dt.maaklerID)
        upsertPropertyInStorage(this.dt);
        this.updateImagesInGenDetails();
        this.mapUserInputToStoreModel();
        this.pushChangesAndExitTo(here);
        if (
          this.dt.availDet.status != "deleted" &&
          this.dt.availDet.status != this.originalStatus
        ) {
          moveProperty(this.originalStatus, this.dt);
        }
      }
    },
    validateCustomPreSaveFields() {
      var validated = true;
      this.$refs.pricingReference.getPriceDaily() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getPriceMonthly() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getEssentialFees() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getCleaningFees() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getDepositDaily() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getWeeklyDiscount() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getDepositMonthly() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getUtilityFees() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getUcc() < 0 ? (validated = false) : void 0;
      this.$refs.pricingReference.getMediumPeriodDiscount() < 0
        ? (validated = false)
        : void 0;
      this.$refs.pricingReference.getLongPeriodDiscount() < 0
        ? (validated = false)
        : void 0;

      if (validated) return true;
      else this.notifyUser("Incorrect or missing price values");
    },
    updateImagesInGenDetails() {
      var finalThumbs = [];
      var finalOrigs = [];
      for (var image of this.dt.marketingDet.images) {
        finalOrigs.push(image.url);
        finalThumbs.push(image.thumb);
      }
      this.dt.genDet.thumbUrls = finalThumbs;
      this.dt.genDet.pictureUrls = finalOrigs;
    },
    removeImage(id) {
      this.$dialog
        .confirm("Continue to Delete")
        .then(() => {
          this.dt.marketingDet.images.splice(id, 1);
        })
        .catch(function (err) {});
    },
    // changeRentedStateBasedOnStatus() {
    //   if (this.status == "archived" && this.statusDesc == "rented")
    //     this.rentedOut = true;
    //   else this.rentedOut = false;
    // },
    validDate(dateString, format) {
      if (dateString === "") return true;
      var date = validateDateString(dateString, format);

      if (!date) return false;
      else return true;
    },
    mapping(obj) {
      this.objectId = obj._id;
      this.dt = obj;
      this.originalStatus = obj.availDet.status;
      this.generalArea = this.dt.techDet.generalArea;
      this.selectedPropertySuperType = this.dt.genDet.propType.superType;
      this.selectedPropertySubType = this.dt.genDet.propType.subType;

      RentStatus.setStatus = this.dt.availDet.status;
      RentStatus.setFromDate = convertDateTimeToDate(
        this.dt.availDet.rentedBetween.from,
        "DD.MM.YYYY"
      );
      RentStatus.setToDate = convertDateTimeToDate(
        this.dt.availDet.rentedBetween.to,
        "DD.MM.YYYY"
      );

      this.status = this.dt.availDet.status;
      sessionStorage.setItem(
        "refreshListingPrevStatus",
        this.dt.availDet.status
      );

      this.statusDesc = this.dt.availDet.statusDesc;

      // if (this.dt.availDet.rentedOut === "true") this.rentedOut = true;
      // else this.rentedOut = false;

      // this.rentedOutStartDate = convertDateTimeToDate(
      //   this.dt.availDet.rentedBetween.from,
      //   "DD.MM.YYYY"
      // );
      // this.rentedOutEndDate = convertDateTimeToDate(
      //   this.dt.availDet.rentedBetween.to,
      //   "DD.MM.YYYY"
      // );
      this.bookedUntil = convertDateTimeToDate(
        this.dt.availDet.bookedUntil,
        "DD.MM.YYYY"
      );

      if (this.dt.availDet.status == "draft") this.draft = true;
      else this.draft = false;

      if (this.dt.techDet.storage.length > 0) this.storage = true;
      else this.storage = false;

      if (this.sale == "true") {
        this.saleView = true;
        this.rentView = false;
      }

      if (this.rent == "true") {
        this.rentView = true;
        this.saleView = false;
      }

      if (this.dt.genDet.propType.superType == "land") this.disabled = true;

      // IMAGES
      let coverImgInx = this.dt.marketingDet.images.findIndex((file) => {
        return file.cover == true;
      });
      if (coverImgInx != -1 && document.getElementById(coverImgInx)) {
        document.getElementById(coverImgInx).classList.remove("hideCover");
        document.getElementById(coverImgInx).classList.add("showCover");
      }

      if (this.dt.marketingDet.videos) {
        for (let i = 0; i < this.dt.marketingDet.videos.length; i++) {
          this.videos.push({ seq: i, url: this.dt.marketingDet.videos[i] });
        }
      }

      // STORAGE
      if (this.dt.techDet.storage.length > 0) this.storage = true;

      if (this.dt.techDet.balcony.length > 0) {
        this.balcon = true;
        this.areaM2 = this.dt.techDet.balcony[0].areaM2;
        this.selectedBalconyType = this.dt.techDet.balcony[0].category;
      } else this.balcon = false;

      // TAGS
      if (
        this.dt.marketingDet.tagwords != null &&
        this.dt.marketingDet.tagwords != ""
      ) {
        this.tagsAsArray = this.dt.marketingDet.tagwords.split(",");
      }

      // AMENITITES
      this.selectedAmenities = this.dt.techDet.amenities;
      this.selectedParkingPayment = this.dt.techDet.parking.payment;
      this.selectedParkingPlacement = this.dt.techDet.parking.placement;

      // HOUSE RULES
      for (var i = 0, n = this.dt.techDet.suitable.length; i < n; i++) {
        switch (this.dt.techDet.suitable[i]) {
          case "pets":
            this.houseRules.pets = true;
            break;
          case "familyFND":
            this.houseRules.kids = true;
            break;
          case "disabFND":
            this.houseRules.disabilities = true;
            break;
          case "smoking":
            this.houseRules.smoking = true;
            break;
          case "events":
            this.houseRules.events = true;
            break;
          case "sublease":
            this.houseRules.sublease = true;
            break;
          default:
            break;
        }
      }

      // PRICING
      this.selectedPriceDaily = this.dt.txnDet.priceDaily;
      this.selectedPriceMonthly = this.dt.txnDet.priceMonthly;
      this.selectedEssentialFees = this.dt.txnDet.essentialsFee;
      this.selectedCleaningFees = this.dt.txnDet.cleaningFees;
      this.selectedDepositDaily = this.dt.txnDet.depositDaily;
      this.selectedWeeklyDiscount = this.dt.txnDet.weeklyDiscount;
      this.selectedDepositMonthly = this.dt.txnDet.depositMonthly;
      this.selectedUtilityFees = this.dt.txnDet.ADDUtiltyFees;
      this.selectedMediumPeriodDiscount = this.dt.txnDet.mediumPeriodDiscount;
      this.selectedLongPeriodDiscount = this.dt.txnDet.longPeriodDiscount;
      this.selectedUcc = this.dt.txnDet.utilityCostCap;
      this.selectedUbc = this.dt.txnDet.utilityBillingCycle;
    },
    uploadStatus(status, tempImageHolders) {
      this.uploadInProgress = true;
    },
    uploadSuccess(tempImageHolders) {
      this.tempImageHolders = tempImageHolders;
      this.uploadInProgress = false;
    },
    uploadError(msg) {
      this.uploadInProgress = false;
    },
    coverIsSet() {
      for (let i = 0; i < this.dt.marketingDet.images.length; i++) {
        if (this.dt.marketingDet.images[i].cover == true) return true;
      }
      return false;
    },
    setcover(id) {
      for (let i = 0; i < this.dt.marketingDet.images.length; i++) {
        this.dt.marketingDet.images[i].cover = false;
      }
      this.dt.marketingDet.images[id].cover = true;
    },
    mapUserInputToStoreModel() {
      try {
        if (this.selectedPropertySuperType)
          this.dt.genDet.propType.superType = this.selectedPropertySuperType;
        if (this.selectedPropertySubType)
          this.dt.genDet.propType.subType = this.selectedPropertySubType;

        if (this.dt.marketingDet.images.length > 0 && !this.coverIsSet())
          this.dt.marketingDet.images[0].cover = true;

        this.dt.marketingDet.videos = [];
        this.videos.forEach((video) => {
          video.url ? this.dt.marketingDet.videos.push(video.url) : void 0;
        });

        let myBalcony;
        if (this.balcon == false) {
          this.dt.techDet.balcony.splice(0);
          this.dt.techDet.nrOfBalconies = 0;
          myBalcony = [];
        } else {
          this.dt.techDet.nrOfBalconies = 1;
          myBalcony = [
            {
              category: this.selectedBalconyType,
              areaM2: parseFloat(this.areaM2),
            },
          ];
        }
        if (this.storage == false) this.dt.techDet.storage.splice(0);

        this.dt.techDet.balcony = myBalcony;

        if (this.daily == "true") {
          this.dt.txnDet.txnType = "rentShortTerm";
        } else {
          this.dt.txnDet.txnType = "rent";
        }

        this.dt.availDet.isBooked = this.booked;
        if (this.booked) {
          this.bookedUntilState = null;
          if (!this.validDate(this.bookedUntil, "DD-MM-YYYY")) {
            //open correct
            this.bookedUntilState = false;
            this.loading = false;

            this.activeName = "fifth";
            return;
          }
          this.bookedUntilState = null;
          this.dt.availDet.bookedUntil = this.bookedUntil;
        } else {
          this.dt.availDet.bookedUntil = "";
        }

        // this.dt.availDet.rentedOut = this.rentedOut;
        // if (this.rentedOut) {
        //   this.rentedOutStartState = null;
        //   this.rentedOutEndState = null;
        //   if (!this.validDate(this.rentedOutStartDate, "DD-MM-YYYY")) {
        //     this.activeName = "fifth";
        //     this.loading = false;
        //     this.rentedOutStartState = false;
        //     return;
        //   }
        //   if (!this.validDate(this.rentedOutEndDate, "DD-MM-YYYY")) {
        //     this.activeName = "fifth";
        //     this.loading = false;
        //     this.rentedOutEndState = false;
        //     return;
        //   }
        //   this.rentedOutStartState = null;
        //   this.rentedOutEndState = null;
        // }
        this.dt.availDet.status = this.status;
        sessionStorage.setItem(
          "refreshListingNewStatus",
          this.dt.availDet.status
        );

        if (this.status == "active") {
          this.dt.availDet.statusDesc = "";
        } else {
          this.dt.availDet.statusDesc = this.statusDesc;
        }

        // if(this.price){
        //   this.dt.txnDet.price = parseFloat((this.price).toFixed(2))
        // }else{
        //   this.dt.txnDet.price = null
        // }
        if (this.generalArea) {
          this.dt.techDet.generalArea = parseFloat(this.generalArea);
        } else {
          this.dt.techDet.generalArea = null;
        }

        this.dt.marketingDet.tagwords = this.tagsAsArray.toString();

        // AMENITIES
        this.dt.techDet.amenities = this.$refs.amenitiesReference.getSelectedAmenities();
        this.dt.techDet.parking.payment = this.$refs.amenitiesReference.getParkingPayment();
        this.dt.techDet.parking.placement = this.$refs.amenitiesReference.getParkingPlacement();

        // PRICING
        this.dt.txnDet.priceDaily = this.$refs.pricingReference.getPriceDaily();
        this.dt.txnDet.priceMonthly = this.$refs.pricingReference.getPriceMonthly();
        this.dt.txnDet.essentialsFee = this.$refs.pricingReference.getEssentialFees();
        this.dt.txnDet.cleaningFees = this.$refs.pricingReference.getCleaningFees();
        this.dt.txnDet.depositDaily = this.$refs.pricingReference.getDepositDaily();
        this.dt.txnDet.weeklyDiscount = this.$refs.pricingReference.getWeeklyDiscount();
        this.dt.txnDet.depositMonthly = this.$refs.pricingReference.getDepositMonthly();
        this.dt.txnDet.ADDUtiltyFees = this.$refs.pricingReference.getUtilityFees();
        this.dt.txnDet.utilityCostCap = this.$refs.pricingReference.getUcc();
        this.dt.txnDet.utilityBillingCycle = this.$refs.pricingReference.getUbc();
        this.dt.txnDet.mediumPeriodDiscount = this.$refs.pricingReference.getMediumPeriodDiscount();
        this.dt.txnDet.longPeriodDiscount = this.$refs.pricingReference.getLongPeriodDiscount();

        if (this.dt.txnDet.priceMonthly && this.generalArea) {
          this.dt.txnDet.m2Price = parseFloat(
            (this.dt.txnDet.priceMonthly / this.generalArea).toFixed(2)
          );
        } else {
          this.dt.txnDet.m2Price = null;
        }

        this.dt.techDet.suitable = [];

        this.houseRules.pets ? this.dt.techDet.suitable.push("pets") : void 0;
        this.houseRules.events
          ? this.dt.techDet.suitable.push("events")
          : void 0;
        this.houseRules.kids
          ? this.dt.techDet.suitable.push("familyFND")
          : void 0;
        this.houseRules.disabilities
          ? this.dt.techDet.suitable.push("disabFND")
          : void 0;
        this.houseRules.smoking
          ? this.dt.techDet.suitable.push("smoking")
          : void 0;
        this.houseRules.sublease
          ? this.dt.techDet.suitable.push("sublease")
          : void 0;
      } catch (err) {
        this.loading = false;
        this.notifyUser("Something is not right");
      }
    },
    exitToPreview() {
      this.navigateTo("listing", { listingId: this.listingId });
    },
    exitToDashboard() {
      this.navigateTo("dashboard");
    },
    validateDate(date, typeState) {
      typeState = null;
      let isValidDate = this.validDate(date, "DD-MM-YYYY");

      if (!isValidDate) {
        this.loading = false;
        typeState = false;
        return false;
      }
      typeState = null;
      return true;
    },
    notifyUser(msg) {
      this.showSnackbar = true;
      this.snackbarMessage = msg;
    },
    changedTab(tabId) {
      this.activeName = tabId;
    },
  },
  data() {
    return {
      askExitConfirmation: false,
      ignoreChanges: false,
      originalStatus: "",
      showSnackbar: false,
      snackbarMessage: "",
      selectedPriceDaily: undefined,
      selectedPriceMonthly: undefined,
      selectedEssentialFees: undefined,
      selectedCleaningFees: undefined,
      selectedDepositDaily: undefined,
      selectedWeeklyDiscount: undefined,
      selectedDepositMonthly: undefined,
      selectedMediumPeriodDiscount: undefined,
      selectedLongPeriodDiscount: undefined,
      selectedUcc: undefined,
      selectedUbc: undefined,
      selectedUtilityFees: [],
      selectedPropertySuperType: "",
      selectedPropertySubType: "",
      selectedAmenities: [],
      selectedParkingPlacement: "",
      selectedParkingPayment: "",
      pricePlaceholder: "€",
      balcon: false,
      selectedBalconyType: "balcony",
      objectId: "",
      draft: false,
      selected: "first",
      loadingText: "Preparing Listing",
      areaM2: undefined,
      priceIncludes: [],
      sale: "true",
      saleView: true,
      rentView: false,
      loading: false,
      dt: listingModel,
      activeName: "second",
      country: lists.countryList,
      propertyType: lists.propertyTypeList,
      subPropertyType: lists.subPropertyTypeList,
      buildingMaterial: lists.buildingMaterialList,
      roofMaterial: lists.roofMaterialList,
      internalWalls: lists.internalWallsList,
      energyLabel: lists.energyLabelList,
      unit: lists.unitList,
      storageList: lists.storageTypeList,
      condition: lists.conditionList,
      readiness: lists.readinessList,
      sanitary: lists.sanitaryTypeList,
      water: lists.waterTypeList,
      currencies: lists.currencyList,
      statuses: lists.statusList,
      statusDescs: lists.statusDescList,
      limitations: lists.limitationList,
      ownerships: lists.ownershipTypeList,
      rules: lists.suitableList,
      heatings: lists.heatingsTypeList,
      additionalFees: lists.utilityFeesTypeList,
      stoves: lists.stovesTypeList,
      daily: "false",
      price: undefined,
      disabled: false,
      storage: false,
      modalShow: false,
      dailyView: false,
      status: "",
      statusDesc: "",
      // rentedOut: false,
      // rentedOutStartDate: "",
      // rentedOutEndDate: "",
      booked: false,
      bookedUntil: "",
      warnRentStatus: false,
      rentedOutStartState: null,
      rentedOutEndState: null,
      bookedUntilState: null,
      rentedOutFromDisplayOnly: "",
      rentedOutToDisplayOnly: "",
      deleteThisListing: false,
      showDeleteInsteadOfSave: false,
      showPublishInsteadOfSave: false,
      generalArea: undefined,
      tagsAsArray: [],
      tempImageHolders: [],
      renderImageUploader: true,
      uploadInProgress: false,
      loadingLocation: false,
      expandNews: false,
      expandSingle: false,
      expandAddImageSection: false,
      expandAddImages: false,
      inputRules: {
        email: (v) => /.+@.+/.test(v) || "Email must be valid",
        required: (value) => !!value || "Required field",
        positiveNumber: (v) =>
          /^[+]?\d+([.]\d+)?$/.test(v) || "Must be positive",
      },
      petsAllowed: "",
      eventsAllowed: "",
      suitableChildren: "",
      disabilityFriendly: "",
      smokingAllowed: "",
      showUploadDialog: false,
      showConfirmCancelDialog: false,
      videos: [],
      houseRules: {
        events: false,
        pets: false,
        kids: false,
        smoking: false,
        disabilities: false,
        sublease: false,
      },
      showActionSnackbar: false
    };
  }
}
</script>
<style scoped>
@import "../assets/styles/global.css";
@import "../assets/styles/images.css";

body {
  font-size: 16px;
}

.img-dragg-container {
  width: 100%;
}

.add-media-dialog {
  height: 100%;
  width: 100%;
  background-color: white;
  padding-left: 2em;
  padding-right: 2em;
}
.active {
  border: none;
}

.hideCover {
  display: none;
}

.nav-pills .nav-link {
  border-radius: 5px;
}

#inputHorizontal {
  width: 100%;
}
.remove-image-btn {
  z-index: 2;
  position: absolute;
  top: 5px;
  right: 5px;
}

.middle {
  z-index: 2;
  color: black;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  background-color: transparent;
  opacity: 0;
}

.down {
  z-index: 2;
  color: #fafafa;
  border-radius: 20px;
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 10px;
  background-color: #1f8efa;
  opacity: 0;
}

.content {
  position: relative;
}

.content:hover .image {
  opacity: 0.2;
  /* background-color:black */
}

.content:hover .remove-image-btn {
  opacity: 1;
}

.content:hover .down {
  opacity: 1;
}
.edit-section-title {
  font-size: 25px;
}

.add-images-over-container {
  position: absolute;
  height: 60vh;
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
  padding: 1em;
  z-index: 999;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  background-color: white;
}

.blur-underline {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f0f4f8c2;
  z-index: 88;
}

.tabs-container {
  display: flex;
  flex-flow: column;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EditListing.vue